import citiesLibrary from './libraries/cities'

/**
 * @return array
 */
const cities = () => ( citiesLibrary )

export default cities



// WEBPACK FOOTER //
// ./src/cities.js